import { css } from '@emotion/react';
import { DesignToken, RadiusToken, SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const container = (isUnknown: boolean) => css`
  max-width: 425px;

  ${MEDIA_MIN_SM} {
    height: calc(100% - 120px);
    min-height: calc(100vh - 120px);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  ${isUnknown &&
  `
    ${MEDIA_MIN_SM} {
      width: 100%;
      max-width: 425px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      height: calc(100% - 164px);
      min-height: calc(100vh - 164px);
    }
  `}
`;

export const textContainer = (isMissingAccess: boolean) => css`
  display: inline-block;
  margin-top: ${isMissingAccess ? '164px' : `90px`};

  ${MEDIA_MIN_SM} {
    margin-top: 0;
  }
`;

export const img = css`
  margin: 60px 0 var(${SpacingToken.Spacing7});
`;

export const text = css`
  margin: var(${SpacingToken.Spacing3}) var(${SpacingToken.Spacing5});
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing1});
`;

export const buttonContainer = css`
  margin-top: var(${SpacingToken.Spacing3});
`;

export const errorMessageButtonStyles = css`
  min-width: 120px;
`;

export const childrenContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: var(${SpacingToken.Spacing3});
  width: inherit;
`;

export const requestIDContainer = css`
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing2});
  padding: var(${SpacingToken.Spacing6});
  border-radius: var(${RadiusToken.Radius2});
  background-color: var(${DesignToken.SurfaceSecondaryDefault});
  margin: var(${SpacingToken.Spacing3}) var(${SpacingToken.Spacing5}) 0;
  word-wrap: break-word;
`;
